export class TemperatureRequirements {
  constructor(tenantId, requirements) {
    this.tenantId = tenantId
    this.requirements = requirements
  }
}

export const TEMPERATURE_99_1 = new TemperatureRequirements(99, '温控货物 2℃-8℃')
export const TEMPERATURE_99_2 = new TemperatureRequirements(99, '温控货物 15℃-25℃')
export const TEMPERATURE_99_3 = new TemperatureRequirements(99, '温控货物 ≤-18℃')
export const TEMPERATURE_13720_1 = new TemperatureRequirements(13720, '温控货物 2℃-8℃')
export const TEMPERATURE_13720_2 = new TemperatureRequirements(13720, '温控货物 15℃-25℃')
export const TEMPERATURE_13720_3 = new TemperatureRequirements(13720, '温控货物 ≤-18℃')
export const TEMPERATURE_REQUIREMENTS = new Set([TEMPERATURE_99_1, TEMPERATURE_99_2, TEMPERATURE_99_3, TEMPERATURE_13720_1, TEMPERATURE_13720_2, TEMPERATURE_13720_3])
